import { fetchGeoCodeFromAddressHttp } from "../http";

async function getLatLong(addressText: string) {

  try {
    const response = await fetchGeoCodeFromAddressHttp(addressText);

    if (response?.data?.results?.length > 0) {
      const location = response.data.results[0].geometry.location;
      const lat = location.lat;
      const lng = location.lng;
      return { lat, lng };
    } else {
      return null; // No results found
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}

export default getLatLong;